import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('ms_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ms_token');
      localStorage.removeItem('ms_user');
      const protectedPaths = ['/cart', '/orders', '/dashboard', '/owner', '/admin'];
      if (protectedPaths.some(path => window.location.pathname.startsWith(path))) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default API;
